// Per-user storage: routes all localStorage.* calls through the signed-in user namespace.
import { scopedStorage as localStorage } from "../services/userStorage";
/**
 * Saves data to localStorage with error handling
 * 
 * @param {string} key - The key to store the data under
 * @param {any} data - The data to store (will be JSON stringified)
 * @returns {boolean} True if successful, false otherwise
 */
export const saveToLocalStorage = (key, data) => {
  try {
    const serializedData = JSON.stringify(data);
    localStorage.setItem(key, serializedData);
    return true;
  } catch (error) {
    console.error(`Error saving data to localStorage (key: ${key}):`, error);
    return false;
  }
};

/**
 * Retrieves data from localStorage with error handling
 * 
 * @param {string} key - The key to retrieve data from
 * @param {any} defaultValue - Default value to return if key doesn't exist
 * @returns {any} The retrieved data or defaultValue if not found
 */
export const getFromLocalStorage = (key, defaultValue = null) => {
  try {
    const serializedData = localStorage.getItem(key);
    if (serializedData === null) {
      return defaultValue;
    }
    return JSON.parse(serializedData);
  } catch (error) {
    console.error(`Error retrieving data from localStorage (key: ${key}):`, error);
    return defaultValue;
  }
};

/**
 * Updates an array item in localStorage
 * 
 * @param {string} key - The localStorage key
 * @param {number} id - ID of the item to update
 * @param {object} updates - Object with properties to update
 * @returns {boolean} True if successful, false otherwise
 */
export const updateItemInLocalStorage = (key, id, updates) => {
  try {
    const items = getFromLocalStorage(key, []);
    const updatedItems = items.map(item => 
      item.id === id ? { ...item, ...updates } : item
    );
    return saveToLocalStorage(key, updatedItems);
  } catch (error) {
    console.error(`Error updating item in localStorage (key: ${key}, id: ${id}):`, error);
    return false;
  }
};

export default {
  saveToLocalStorage,
  getFromLocalStorage,
  updateItemInLocalStorage
};